import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Container, Col, Row, Label } from 'reactstrap'
import DataWrapper from '../../principal/containers/DataWrapper'
import FiltroBookingDepot from '../components/FiltroBookingDepot'
import TabelaBookingDepot from '../components/TabelaBookingDepot'
import BookingDepotStore from '../stores/BookingDepotStore'
import Footer from '../../comum/components/Footer'
import FooterContent from '../../comum/components/FooterContent'
import ModalAssociacaoDepot from '../components/ModalAssociacaoDepot'
import CardAtencao from '../../comum/components/CardAtencao'
import { IconeCarregar } from '../../comum/components/Icones'
import ModalAviso from '../../comum/components/ModalAviso'

@inject("store")
@DataWrapper
@observer
export class BookingDepot extends Component {

    constructor(props) {

        super(props)

        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.controller = new BookingDepotStore()

    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Associar Booking Depot");

        //TODO: Provavelmente botar um loading indicando que estou recebendo as informações desta requisição
        this.controller.listarArmadorDepotDefault()
    }

    modalAssocDessoc() {
        return this.controller.modalAssocDessoc && <ModalAssociacaoDepot controller={this.controller} />
        
    }

    modalMensagem() {
        return this.controller.alerta !== "" && 
        <ModalAviso onClickFechar={this.controller.fecharModalAlerta}>
            <h2>
                {this.controller.alerta}
            </h2>
        </ModalAviso>
    }

    render() {
        if(this.controller.loadingDefault) {
            return <Row className="justify-content-center">
                    <IconeCarregar tamanho="2x" />
                </Row>
        } else {
            return (
                <div className="form-wrapper">
                    {this.modalMensagem()}
                    {this.modalAssocDessoc()}
                    <Container className="liberacao-cabotagem tela-botoes-inclusao-topo" fluid>
                    <Row className={`botoes-inclusao-topo justify-content-end align-items-center`}>
                        {
                            this.controller.listaDefault.length > 0 && this.controller.listaDefault[0].depot !== null
                            ?
                            <div
                                className="card-atencao mr-4"
                                style={{minWidth:'unset', margin: '5px', padding: '5px 20px'}}
                            >
                                <div className="card-atencao--title">Depot Default Associado</div>
                            </div>
                            :
                            null
                        }
                        <Button className="btn-com-bordas-primary mr-3" onClick={() => this.controller.abrirModalAssoc(null, "AssocDefault")}>
                            {
                                this.controller.listaDefault.length > 0
                                ?"Editar Depot Default"
                                :"Associar Depot Default"
                            }
                        </Button>
                    </Row>
                        <FiltroBookingDepot controller={this.controller} />
                        <TabelaBookingDepot controller={this.controller} />
                    </Container>
                    <Footer>
                        <FooterContent>
                        {this.controller.itens !== null &&
                            <div className="justify-content-between">
                                <div>
                                    <b>{this.controller.itens.length}</b> {this.controller.itens === 1 ? 'item encontrado' :'itens encontrados'} -
                                    <a onClick={this.controller.listarBookings}>Atualizar Lista</a>
                                </div>
                            </div>
                        }
                        </FooterContent>
                    </Footer>
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/bookingdepot/telas/BookingDepot.js